import React, { useEffect, useRef, useMemo, useState } from "react";
import { useSelector } from "react-redux";
const BenchmarkedDescription = () => {

  const themeMode = useSelector((state) => state.themeMode);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);
  const leftMenuVisibility = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.leftMenuVisibility;

  const currentSurveyInsightData = useMemo(() => {
    const activeTab = topMenuTabs.tabs.find(
      (tab) => tab.id === topMenuTabs.activeTab
    );
    return activeTab ? activeTab.states.currentSurveyInsightData : null;
  }, [topMenuTabs.tabs, topMenuTabs.activeTab]);

  const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;

  return (
    <div
      className={`flex flex-col w-full justify-start items-start pl-0 pt-16 ${themeMode === "dark"
          ? "bg-[#1a1a28] text-white"
          : "bg-[#fbfbfc] text-black"
        }`}
    >
      <div className="flex items-start 2xl:items-end space-x-6 relative flex-1 top-0">
        <div
          className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 4xl:grid-cols-5 w-full justify-center p-8 flex-1`}
        >
          {currentSurvey?.stages?.map((step, index) => (
            <div
              key={index}
              className="max-w-full  p-4 shadow-md text-center 2xl:!hidden"
            >
              <h3
                className={`  ${themeMode === "dark"
                    ? "bg-gray-500"
                    : "bg-gray-700"
                  } text-white py-2 px-3 font-bold text-lg mb-4`}
              >
                {index + 1}. {step.name}
              </h3>
              <p
                className={`text-[18px] ${themeMode === "dark" ? "text-white" : "text-gray-700"
                  }`}
              >
                {step.description}
              </p>
            </div>
          ))}
        </div>
        {currentSurvey?.stages?.map((step, index) => (
          <div
            key={index}
            style={{
              marginBottom: index === 0 ? "200px" : `${index * 80 + 200}px`, // Her adımı yukarı kaydırıyoruz
              left: `${index * 60}px`, // Her adımı sağa kaydırıyoruz
            }}
            className={` items-center text-center w-[250px] hidden 2xl:flex 2xl:flex-col`}
          >
            <span
              className={`text-lg font-bold mb-2       ${themeMode === "dark"
                  ? "text-white"
                  : "text-black"
                }`}
            >
              {index + 1}. {step.name}
            </span>
            <div className="relative w-full h-[120px]">
              {/* Poligonal border efektini içeren dekoratif katman */}
              <div
                className={`absolute inset-0 p-4 border-l-[20px] border-t-[20px] 
                  ${themeMode === "dark"
                    ? "border-gray-500"
                    : "border-gray-700"
                  }`}
                style={{
                  clipPath: "polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%)",
                  pointerEvents: "none",
                }}
              />

              {/* Metin kapsayıcısı: Poligonal efektten etkilenmeyecek şekilde konumlandırıyoruz */}
              <div
                className="absolute left-1/2 transform -translate-x-1/2 p-2"
                style={{
                  bottom: "10px", // Parent'ın altına sabitlemek için
                  width: "230px",
                  maxWidth: "230px", // Genişlik sınırı
                  height: "80px",
                  maxHeight: "auto", // İçerik fazla ise scroll etsin
                  background: "transparent", // Gerekirse arka planı ayarlayın (örn. yarı saydam)
                }}
              >
                <p
                  className={`text-sm ${themeMode === "dark" ? "text-white" : "text-gray-700"
                    }`}
                >
                  {step.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default BenchmarkedDescription;
